import type { ReactNode } from 'react';

interface FeatureUnavailableNoticeProps {
  /** What is not available, e.g. "Electronic tax filing". */
  feature: string;
  /** Accurate, plain-language statement of why and what has NOT happened. */
  children: ReactNode;
}

/** EPN-98 — shown in place of an action whose backing provider is mock-only (see
 * `shared/commercialActions.ts`). `role="status"`; the label text, not colour, carries the state. */
export function FeatureUnavailableNotice({ feature, children }: FeatureUnavailableNoticeProps) {
  return (
    <div role="status" data-testid="feature-unavailable">
      <p>
        <span className="badge badge--caution">Not available in this release</span>{' '}
        <strong>{feature}</strong>
      </p>
      <p className="muted">{children}</p>
    </div>
  );
}
